import i18n, { lngs } from '../i18n';
import { DATA_I18N_SET_RESOURCE } from '../constants';

export default function createApiI18nMiddleware(req) {
  return store => next => action => {
    if (!action) {return next(action);}

    if (action.status !== 'SUCCESS' || !action.i18n) {
      return next(action);
    }

    const { transform } = action.i18n;

    let resource = action.response;

    if (transform) {
      resource = transform(resource);
    }

    lngs.forEach(l => {
      if (resource[l]) {
        for (let ns of Object.keys(resource[l])) {
          i18n.addResourceBundle(l, ns, resource[l][ns]);
          store.dispatch({
            type: DATA_I18N_SET_RESOURCE,
            resource: {
              lang: l,
              namespace: ns,
              resource: resource[l][ns]
            }
          });
        }
      }
    });

    return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/middleware/i18n.js